import mus1 from "../assets/1_4945219640897830976.mp3"
import mus2 from "../assets/akon-lonely.mp3"
import mus3 from "../assets/Akon-Cross the line.mp3"
import mus4 from "../assets/1_5168310249525870619.mp3"
import mus5 from "../assets/15 Jonestown (Interlude) - (www.SongsLover.club).mp3"
import img1 from "../assets/Rectangle29.png"
import img2 from "../assets/Rectangle15.png"
import img3 from "../assets/Rectangle16.png"
import img4 from "../assets/Rectangle17.png"
import img5 from "../assets/Rectangle19.png"

export const songlib = [
    {
      title: "Somewhere In Brooklyn",
      artist: "Bruno Mars",
      time:
        "2:34:45",
      img: <img className="tyu" src={img1} alt="img" />,
      musc: mus1,
    
    },
    {
        title: "Lonely",
        artist: "Akon",
        time:
          "1:02:42",
        img:  <img src={img2} alt="img" />,
        musc: mus2,
      },
      {
        title: "Cross the line",
        artist: "Akon",
        time:
          "2:01:25",
        img:  <img src={img3} alt="img" />,
        musc: mus3,
      },
      {
        title: "Tresure",
        artist: "Bruno Mars",
        time:
          "2:34:45",
        img:  <img src={img4} alt="img" />,
        musc: mus4,
      },
      {
        title: "Jonestown(Interlude)",
        artist: "Post Malone",
        time:
          "2:01:25",
        img:  <img src={img5} alt="img" />,
        musc: mus5,
      },
 
  ];
  